import {select} from 'd3-selection';
import legend from '../../modules/legend';
import {className} from '../../modules/util';

function renderLegend(field = 'region') {
  let legendToggle = this.legend();
  if (!legendToggle) return;
  const fieldObj = this.__execs__.field;
  if (!legendToggle.format && fieldObj[field].interval) legendToggle.format = fieldObj[field].format;
  let x,y,width, height;
  let offset =  this.offset();
  let innerSize = this.innerSize();
  let margin = this.margin();
  let offsetThickness = legendToggle.font ? legendToggle.font['font-size'] : 20;
  if (legendToggle.orient === 'bottom' || legendToggle.orient === 'top') {
    if (this.axisX && !this.axisX()) offsetThickness *= 1.71;
    x = 0;
    if (legendToggle.orient === 'bottom') y = innerSize.height  + offset.bottom - margin.bottom - legendToggle.thickness + offsetThickness;
    else y = - offset.top + margin.top - offsetThickness;
    width = innerSize.width;
    height = legendToggle.thickness - offsetThickness;
  } else {
    if (legendToggle.orient === 'right') x = innerSize.width + offset.right - legendToggle.thickness;
    else x = - offset.left + margin.left - offsetThickness;
    y = offsetThickness / 2;
    width = legendToggle.thickness - offsetThickness;
    height = innerSize.height - offsetThickness/2;
  }
  let colorScale = this.scale().color;
  let legendObj = legend().scale(colorScale)
    .x(x).y(y)
    .width(width).height(height)
    .orient(legendToggle.orient)
    .format(legendToggle.format)
    .highlightColor(this.highlightColor())
    .transition(this.transition());
  this.__execs__.legend = legendObj;

  legendObj.on('selectEnter', d => {
    if (this.highlightFromLegend) {
      this.highlightFromLegend(d);
    }
  }).on('selectLeave', d => {
    if (this.dehighlightFromLegend) {
      this.dehighlightFromLegend(d);
    }
  })

  let canvas = this.__execs__.canvas;
  
  let legendSel = canvas.selectAll(className('legend', true))
    .data([legendObj]);
  legendSel.exit().remove();
  legendSel.enter().append('g')
    .attr('class', className('legend'))
    .merge(legendSel)
    .each(function(legend) {
      legend.render(select(this));
    });
  return this;
}

export default renderLegend;


// WEBPACK FOOTER //
// ../node_modules/daisy-chart/src/layouts/default/renderLegend.js